import { useMemo } from "react";
import { SelectSlider } from "./select-slider.component";
import styles from "./range-slider.module.css";

interface Props {
  label?: string;
  min: number;
  max: number;
  step?: number;
  value: number;
  onChange: (value: number) => void;
}

type Item = {
  value: string;
  label: string;
};

export function RangeSlider({
  label = "Alcance da busca",
  min,
  max,
  step,
  value,
  onChange,
}: Props) {
  const radiusList: Item[] = useMemo(
    () => [
      { value: "0", label: "0 Km" },
      { value: "50", label: "50 Km" },
      { value: "100", label: "100 Km" },
      { value: "150", label: "150 Km" },
      { value: "200", label: "200 Km" },
    ],
    []
  );

  const dropdownValue = useMemo(() => {
    return radiusList.find((item) => Number.parseInt(item.value, 10) === value);
  }, [radiusList, value]);

  const getBackground = useMemo(() => {
    const percentage = ((value - min) / (max - min)) * 100;
    return `linear-gradient(90deg, #5a5edc ${percentage}%, #d0cfda ${percentage}%)`;
  }, [value, min, max]);

  return (
    <div className={styles.SliderContainer}>
      <div>
        <span className={styles.SliderLabel}>{label}</span>
        <div className={styles.SliderValueContainer}>
          <SelectSlider
            items={radiusList}
            value={dropdownValue ?? radiusList[0]}
            onChange={(item) => onChange(Number.parseInt(item.value, 10))}
          />
        </div>
      </div>
      <div className={styles.SliderWrapper}>
        <input
          type="range"
          min={min}
          max={max}
          step={step}
          value={value}
          onChange={(e) => onChange(Number.parseInt(e.target.value, 10))}
          className={styles.Slider}
          style={{ background: getBackground }}
        />
      </div>
    </div>
  );
}
